"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tertiaryPreset = exports.secondaryPreset = exports.primaryPreset = void 0;
var strategy_builder_1 = __importDefault(require("./strategy-builder"));
var BACKOFF_INITIAL = 150;
function primaryPreset(transport) {
    return (0, strategy_builder_1.default)(transport).withBackoff(BACKOFF_INITIAL).build();
}
exports.primaryPreset = primaryPreset;
function secondaryPreset(transport) {
    return (0, strategy_builder_1.default)(transport)
        .withDelay(4000)
        .withBackoff(BACKOFF_INITIAL)
        .build();
}
exports.secondaryPreset = secondaryPreset;
function tertiaryPreset(transport) {
    return (0, strategy_builder_1.default)(transport)
        .withDelay(8000)
        .withBackoff(BACKOFF_INITIAL)
        .build();
}
exports.tertiaryPreset = tertiaryPreset;
//# sourceMappingURL=strategy-presets.js.map